import React from 'react';
import Seo from './Seo';
import Icon from './Icon';
import { SiteHeader, SiteFooter } from './SiteChrome';
export default function StatusPage({ title, message, icon='mail', children }) {
  return <div className="f1000-site"><Seo title={`${title} — First 1000`} robots="noindex,nofollow"/><SiteHeader/><main id="main" className="f1000-status"><div className="f1000-status-mark"><Icon name={icon} size={36}/></div><h1>{title}</h1><p role="status">{message}</p>{children}<div className="f1000-status-links"><a href="/">Back to First 1000 <Icon size={16}/></a><a href="https://first1000.substack.com/archive">Read the archive <Icon size={16}/></a></div></main><SiteFooter/></div>;
}
